export function marquee() {
  const marquees = document.querySelectorAll('.marquee');
  if (!marquees.length) return;

  marquees.forEach((marquee) => {
    // 対象コンテナ・コンテンツの存在チェック（早期リターン）
    const marqueeContainer = marquee.querySelector('.marquee-container');
    const marqueeContent = marquee.querySelector('.marquee-content');
    if (!marqueeContainer || !marqueeContent) return;

    const marqueeElements = marqueeContent.querySelectorAll('.marquee-element');
    if (!marqueeElements.length) return;

    // data属性からパラメータを読み込み
    const speed = Number(marquee.dataset.speed) || 1;
    const direction = marquee.dataset.direction === 'right' ? 1 : -1;
    const pauseOnHover = marquee.dataset.pause === 'true';
    const noScrollIfFit = marquee.dataset.noScrollIfFit === 'true';

    let pause = false;
    let currentPosition = 0;
    let isActive = false;
    let isStatic = false;
    let initialized = false;

    // CSS transform用の関数
    const setTransform = (position) => {
      marqueeContainer.style.transform = `translate3d(${position}px, 0, 0)`;
    };

    // marquee-contentの幅を取得（ループの基準点）
    let contentBlockWidth = 0;

    // marquee-elementの合計幅を計算
    const getElementsTotalWidth = () => {
      let totalWidth = 0;
      marqueeElements.forEach((el) => {
        const style = window.getComputedStyle(el);
        const marginLeft = parseFloat(style.marginLeft) || 0;
        const marginRight = parseFloat(style.marginRight) || 0;
        totalWidth += el.offsetWidth + marginLeft + marginRight;
      });
      return totalWidth;
    };

    // コンテンツがコンテナに収まるかチェック
    const contentFitsContainer = () => {
      const containerWidth = marquee.offsetWidth;
      const elementsWidth = getElementsTotalWidth();
      return elementsWidth <= containerWidth;
    };

    // 要素をクローンしてコンテナ幅を超えるまで増やす
    const ensureEnoughWidth = () => {
      const containerWidth = marquee.offsetWidth;

      // marquee-content内の要素が足りない場合、要素を順番にクローンして追加
      while (marqueeContent.offsetWidth < containerWidth) {
        for (const el of marqueeElements) {
          marqueeContent.appendChild(el.cloneNode(true));
          if (marqueeContent.offsetWidth >= containerWidth) break;
        }
      }

      // この時点でのmarquee-contentの幅を記録（ループ基準）
      contentBlockWidth = marqueeContent.offsetWidth;

      // シームレスなループのためにmarquee-contentをクローン
      while (marqueeContainer.scrollWidth < containerWidth * 2) {
        marqueeContainer.appendChild(marqueeContent.cloneNode(true));
      }
    };

    // クローンされた要素をクリア
    const clearClones = () => {
      // marquee-container内のクローンされたmarquee-contentを削除（最初の1つを残す）
      const clonedContents = marqueeContainer.querySelectorAll('.marquee-content');
      for (let i = 1; i < clonedContents.length; i++) {
        clonedContents[i].remove();
      }
      // marquee-content内のクローンされた要素を削除
      const allElements = marqueeContent.querySelectorAll('.marquee-element');
      for (let i = marqueeElements.length; i < allElements.length; i++) {
        allElements[i].remove();
      }
    };

    // 静的表示に切り替え
    const setStaticMode = () => {
      clearClones();
      marquee.classList.remove('is-active');
      marquee.classList.add('is-static');
      setTransform(0);
      isActive = false;
      isStatic = true;
    };

    // アニメーション表示に切り替え
    const setAnimateMode = () => {
      marquee.classList.remove('is-static');
      ensureEnoughWidth();
      marquee.classList.add('is-active');
      isActive = true;
      isStatic = false;
    };

    // マーキーを初期化
    const initMarquee = () => {
      if (initialized) return;

      // noScrollIfFitが有効で、コンテンツがコンテナに収まる場合は静的表示
      if (noScrollIfFit && contentFitsContainer()) {
        setStaticMode();
      } else {
        ensureEnoughWidth();
        marquee.classList.add('is-active');
        isActive = true;
      }
      initialized = true;
    };

    // リサイズ時に再チェック
    const handleResize = () => {
      if (!noScrollIfFit) return;

      const fits = contentFitsContainer();

      if (fits && !isStatic) {
        setStaticMode();
      } else if (!fits && isStatic) {
        setAnimateMode();
      }
    };

    // ループ位置更新
    const updatePosition = () => {
      if (!isActive) return;

      currentPosition += speed * direction;

      // 右方向スクロールの場合
      if (direction > 0) {
        if (currentPosition >= contentBlockWidth) {
          currentPosition = 0;
        }
      }
      // 左方向スクロールの場合
      else {
        if (Math.abs(currentPosition) >= contentBlockWidth) {
          currentPosition = 0;
        }
      }

      setTransform(currentPosition);
    };

    const animate = () => {
      if (!pause) updatePosition();
      requestAnimationFrame(animate);
    };

    // マウスホバーで一時停止（必要な場合）
    if (pauseOnHover) {
      marquee.addEventListener('mouseover', () => (pause = true));
      marquee.addEventListener('mouseout', () => (pause = false));
    }

    // リサイズイベント（デバウンス付き）
    if (noScrollIfFit) {
      let resizeTimeout;
      window.addEventListener('resize', () => {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(handleResize, 150);
      });
    }

    // 初期位置を設定
    setTransform(currentPosition);

    // アニメーション開始
    animate();

    // 初期化（フォント読み込み完了後）
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(() => {
        initMarquee();
      });
    } else {
      setTimeout(initMarquee, 100);
    }
  });
}
